import React from "react";
import { forgotpassword } from "../../../../../common/lib/forgotpassword";
import CustomCarousel from "../../../carousel/theme11/CustomCarousel";
import { noLeadingSpace } from "../../../../lib/utils/regex_cheat_sheet";

export default class ForgotPassword extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      emailError: "",
      generalError: "",
      onClickLoginLoader: false,
    };
  }

  handleChangeEmail = (e) => {
    const value = e.target.value;
    if (!noLeadingSpace.test(value) && value.length === 1) {
      return;
    }
    let error = "";
    if (!value) {
      error = "Please enter email id.";
    } else if (!/^\S+@\S+\.\S+$/.test(value)) {
      error = "Please enter a valid email address.";
    }
    this.setState({ email: value, emailError: error });
  };

  handleBlurEmail = (e) => {
    const value = e.target.value;
    let error = "";
    if (!value) {
      error = "Please enter email id.";
    } else if (!/^\S+@\S+\.\S+$/.test(value)) {
      error = "Please enter a valid email address.";
    }
    this.setState({ emailError: error });
  };

  handleSubmit = async () => {
    const { email, emailError } = this.state;
    if (!email || emailError) {
      this.setState({ emailError: emailError || "Please enter email id." });
      return;
    }
    this.setState({ generalError: "", onClickLoginLoader: true });
    try {
      const forgotPassReq = { email };
      const res = await forgotpassword(forgotPassReq);
      if (res && res.status === true && res.message && res.message !== "") {
        this.setState({ onClickLoginLoader: false });
        if (
          this.props.handlers &&
          typeof this.props.handlers.setPopupType === "function"
        ) {
          this.props.handlers.setPopupType({
            popupCompoenet: "login",
            popupPage: "RequestConfirmed",
          });
        }
      } else {
        this.setState({
          generalError:
            res && res.message ? res.message : "Failed to send request.",
          onClickLoginLoader: false,
        });
      }
    } catch (error) {
      this.setState({
        generalError: "Failed to send request.",
        onClickLoginLoader: false,
      });
    }
  };

  handleBackToLogin = () => {
    if (
      this.props.handlers &&
      typeof this.props.handlers.setPopupType === "function"
    ) {
      this.props.handlers.setPopupType({
        popupCompoenet: "login",
        popupPage: "LoginWithEmail",
      });
    }
  };

  render() {
    const { styles, PromotionBannerCss, isMobile } = this.props;

    const { email, emailError, generalError } = this.state;
    // --- New banner logic using PromotionBanner ---
    const imageLoader = ({ src }) => {
      const url = `/shared/api/media/${src}`;

      return url;
    };

    const CustomPrevArrow = () => (
      <img src="/images/arrow_2-01.svg" width={20} height={20} alt="Previous" />
    );
    const CustomNextArrow = () => (
      <img src="/images/back-arrow.png" width={20} height={20} alt="Next" />
    );

    const customResponsive = {
      desktop: { breakpoint: { max: 3000, min: 1024 }, items: 1 },
      tablet: {
        breakpoint: { max: 1024, min: 464 },
        items: 2,
        slidesToSlide: 2,
      },
      mobile: { breakpoint: { max: 464, min: 0 }, items: 1, slidesToSlide: 1 },
    };

    const banners = this.props?.siteData?.data?.signin?.banners;

    return (
      <div className={styles.main_content}>
        {/* Left side - Promotional Banner (dynamic) */}
        <div className={styles.login_banner}>
          <CustomCarousel
            banners={banners}
            imageLoader={imageLoader}
            cssstyles={PromotionBannerCss}
            arrows={false}
            dots={true}
            autoplay={false}
            imageKey="upload_image"
            prevArrow={"/images/back-arrow.png"}
            nextArrow={"/images/back-arrow.png"}
            responsive={customResponsive}
          />
          {isMobile ? (
            <div className={styles.banner_left_arrrow}>
              <img src="images/te_Left_Arrow.svg" alt="arrow" />
            </div>
          ) : null}
        </div>

        {/* Right side - Login Form */}
        <div className={styles.login_section}>
          <div className={`${styles.login_form} ${styles.forgot_form}`}>
            <div className={styles.form_header}>
              <h3>Forgot Password</h3>
              <div className={styles.form_subtitle}>
                <span>Don’t worry, happens to all of us.</span>
                <span>Enter your details below to recover your password</span>
              </div>
              {generalError && (
                <div className={styles.error_message} id="error-message">
                  <div className={styles.error_icon}>
                    <img src="images/te_Invalied.svg" alt="Invalid icon" />
                  </div>
                  <span>{generalError}</span>
                </div>
              )}
            </div>

            <div className={`${styles.form_group} ${styles.form_forgot_group}`}>
              <label htmlFor="email">Email ID</label>
              <div className={styles.input_container}>
                <input
                  id="email"
                  placeholder="Enter your email id"
                  className={`${styles.normal_input} ${emailError ? styles.input_error : ""
                    }`}
                  value={email}
                  onChange={this.handleChangeEmail}
                  onBlur={this.handleBlurEmail}
                />
                {emailError && (
                  <div className={styles.error_text} id="email-error">
                    {emailError}
                  </div>
                )}
              </div>
            </div>

            <button
              className={`${styles.login_btn} ${this.state.onClickLoginLoader ? "loading" : ""
                }`}
              onClick={this.handleSubmit}
            >
              <span>Submit</span>
              <img src="images/te_Arrow_right.svg" alt="arrow" />
            </button>
            <div className={styles.register_link}>
              <span
                className={styles.back_to_login}
                onClick={this.handleBackToLogin}
              >
                Back to Login
              </span>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
